const IntroSection = () => {
  return (
    <section className="bg-cream py-32 px-6">
      <div className="max-w-7xl mx-auto">
        <div className="grid grid-cols-2 gap-16 items-center">
          <div className="relative">
            <div className="rounded-[32px] overflow-hidden shadow-xl w-full h-[600px]">
              <img
                src="https://public.readdy.ai/ai/img_res/56eb867941fbaa59ee82543558d7921b.jpg"
                alt="Riverdale Hair Studio Interior"
                className="w-full h-full object-cover object-top"
              />
            </div>
          </div>

          <div className="pl-8">
            <div className="inline-block px-4 py-2 bg-blush rounded-full mb-5">
              <span className="text-xs uppercase tracking-wider text-charcoal font-sans font-medium">
                About Us
              </span>
            </div>

            <h1 className="text-5xl font-bold text-charcoal font-serif mb-6 leading-tight">
              Your Local Hair & Beauty Experts
            </h1>

            <div className="space-y-5 text-base text-gray-700 font-sans leading-relaxed">
              <p>
                Welcome to <strong>Riverdale Hair Studio</strong>, where style meets confidence in the heart of <strong>Otley</strong>. Since opening our doors in 2018, we've been dedicated to providing exceptional hair services to the local <strong>West Yorkshire community</strong>.
              </p>
              <p>
                Our experienced team of stylists combines technical expertise with genuine care for each client. We believe that great hair is about more than just a cut or colour—it's about understanding your lifestyle, preferences, and helping you feel your absolute best.
              </p>
              <p>
                From precision cutting and creative colouring to special occasion styling, we use only premium products and the latest techniques. But what truly sets us apart is our commitment to personalised service and building lasting relationships with our clients in <strong>Otley and the surrounding areas</strong>.
              </p>
            </div>

            <a
              href="/contact"
              className="inline-flex items-center gap-2 mt-10 px-8 py-3 border-2 border-sage text-sage font-sans text-sm font-medium rounded-full hover:bg-sage hover:text-white transition-all whitespace-nowrap cursor-pointer"
            >
              Meet the Team
              <i className="ri-arrow-right-line"></i>
            </a>
          </div>
        </div>
      </div>
    </section>
  );
};

export default IntroSection;